import { createContext } from "react";
var SecureMessageSortingType;
(function (SecureMessageSortingType) {
    SecureMessageSortingType["Date"] = "Date";
    SecureMessageSortingType["AZ"] = "AZ";
    SecureMessageSortingType["ZA"] = "ZA";
})(SecureMessageSortingType || (SecureMessageSortingType = {}));
var SecureMessageStatus;
(function (SecureMessageStatus) {
    SecureMessageStatus["All"] = "All";
    SecureMessageStatus["Unread"] = "Unread";
    SecureMessageStatus["Archive"] = "Archive";
})(SecureMessageStatus || (SecureMessageStatus = {}));
const SecureMessageContext = createContext(null);
export { SecureMessageContext, SecureMessageStatus, SecureMessageSortingType };
